module.exports = __webpack_public_path__ + "static/media/unconcious-bias.76adcfe5.jpg";